import React from 'react';
import '../HomePage/Styles.css';
import ContactSection from '../../components/ContactSectionPage/Index';
import { Link } from 'react-router-dom';
import useTitle from '../../useTitle';

const HomePagina = () => {
   useTitle("Bold Yet Refined Handcrafted in Antwerp");

  return (
    <>
      {/* Header */}
      <div className='headerSection'>
        <div className='headerHero'>
          {[...Array(10)].map((_, i) => (
            <div key={i} className={`slide slide${i+1}`}></div>
          ))}
        </div>
      </div>

      {/* Slogan */}
      <div className='sloganSection'>
        <div className='sloganSectionText'>
          <p className='sloganText'>Bold yet refined, handcrafted in Antwerp.</p>
        </div>
      </div>

      {/* Catalog */}
      <div className='catalogusSection'>
        <Link to="/category/rings">
          <div className='productCategorieOne'>
            <div className='productCategorieOneImageSection'>
              <img src='/images/ringen/ring.jpeg' className='ringImageSection' alt='rings foto' />
            </div>
            <div className='productCategorieOneDescriptionSection'>
              <h2 className='productCategorieOneDescriptionSectionTitle'>Rings</h2>
            </div>
          </div>
        </Link>

        <Link to="/category/earrings">
          <div className='productCategorieTwo'>
            <div className='productCategorieTwoImageSection'>
              <img src='/images/oorbellen/earrings.jpeg' className='ringImageSection' alt='earrings foto' />
            </div>
            <div className='productCategorieTwoDescriptionSection'>
              <h2 className='productCategorieTwoDescriptionSectionTitle'>Earrings</h2>
            </div>
          </div>
        </Link>

        <Link to="/category/bracelets">
          <div className='productCategorieThree'>
            <div className='productCategorieThreeImageSection'>
              <img src='/images/bracelets/bracelets.jpeg' className='ringImageSection' alt='bracelets foto' />
            </div>
            <div className='productCategorieThreeDescriptionSection'>
              <h2 className='productCategorieThreeDescriptionSectionTitle'>Bracelets</h2>
            </div>
          </div>
        </Link>

        <Link to="/category/pendants">
          <div className='productCategorieFour'>
            <div className='productCategorieFourImageSection'>
              <img src='/images/pendants/pendants.jpeg' className='ringImageSection' alt='pendants foto' />
            </div>
            <div className='productCategorieFourDescriptionSection'>
              <h2 className='productCategorieFourDescriptionSectionTitle'>Pendants</h2>
            </div>
          </div>
        </Link>

        <Link to="/category/tie-clips-and-cufflinks">
          <div className='productCategorieFive'>
            <div className='productCategorieFiveImageSection'>
              <img src='/images/tieclips/tieclip.jpeg' className='ringImageSection' alt='tie clips foto' />
            </div>
            <div className='productCategorieFiveDescriptionSection'>
              <h2 className='productCategorieFiveDescriptionSectionTitle'>Tie Clips & Cufflinks</h2>
            </div>
          </div>
        </Link>

        <Link to="/category/brooches-and-hairpins">
          <div className='productCategorieSix'>
            <div className='productCategorieSixImageSection'>
              <img src='/images/broochesandhairpins/brooches.jpeg' className='ringImageSection' alt='new category foto' />
            </div>
            <div className='productCategorieSixDescriptionSection'>
              <h2 className='productCategorieSixDescriptionSectionTitle'>Brooches & Hairpins</h2>
            </div>
          </div>
        </Link>
      </div>

      {/* Custom Jewelry */}
      <div className='customJewelryHomeSection'>
        <Link to='/customjewelry' className='customJewelryButton'>
          CUSTOM JEWELRY
        </Link>
      </div>

      <ContactSection />
    </>
  )
}

export default HomePagina;